module.exports = __webpack_public_path__ + "73a8a0f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/best_sto.png
// module id = 1975
// module chunks = 0 15 17 22